import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { Button } from "@/components/ui/button";

const DISMISS_KEY = "as_auto_pwa_dismissed";

export function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);

    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    if (isIos) { setIosHint(true); setShow(true); }

    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  const dismiss = () => { setShow(false); localStorage.setItem(DISMISS_KEY, "1"); };

  if (!show) return null;

  return (
    <div data-testid="pwa-install-banner" className="fixed bottom-4 inset-x-4 z-[60] mx-auto max-w-md">
      <div className="relative flex items-center gap-4 bg-[#121212] border border-[#C5A059]/40 rounded-sm p-4 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.8)]">
        <img src="/icon-192.png" alt="AS AUTO" className="h-12 w-12 rounded-lg" />
        <div className="flex-1 min-w-0">
          <p className="font-display font-semibold text-white text-sm">Installer l'application AS AUTO</p>
          {iosHint ? (
            <p className="text-xs text-neutral-400 mt-0.5 flex items-center gap-1">
              Appuyez sur <Share className="h-3 w-3 inline" /> puis « Sur l'écran d'accueil »
            </p>
          ) : (
            <p className="text-xs text-neutral-400 mt-0.5">Accès plein écran depuis votre écran d'accueil.</p>
          )}
        </div>
        {!iosHint && (
          <Button data-testid="pwa-install-btn" onClick={install} size="sm" className="bg-[#C5A059] text-black hover:bg-[#E6C678] rounded-sm shrink-0">
            <Download className="h-4 w-4 mr-1.5" /> Installer
          </Button>
        )}
        <button data-testid="pwa-dismiss-btn" onClick={dismiss} className="text-neutral-500 hover:text-white shrink-0" aria-label="Fermer">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
